if (!customElements.get("google-calendar-trigger")) {
    class HoculusGoogleCalendarTrigger extends HTMLElement {
        constructor() {
            super();
        }
        
        connectedCallback() {
            this.button = this.querySelector("button");
            this.gCalendarBtnWrapper = document.getElementById("hoculus-gc-btn-wr");
            
            this.button?.addEventListener("click", this.clickHandler);

            if (!this.gCalendarBtnWrapper) {
                this.createGCalendarBtn("hoculus-gc-btn-wr");
            }
        }

        disconnectedCallback () {
            this.button?.removeEventListener("click", this.clickHandler)
        }

        createGCalendarBtn (wrapperId) {
            const btnWrapper = document.createElement("div");
            const btnTarget = document.createElement("div");

            btnWrapper.style.display = "none";
            btnWrapper.id = wrapperId;

            btnWrapper.appendChild(btnTarget);
            document.body.appendChild(btnWrapper);

            this.gCalendarBtnWrapper = btnWrapper;

            try {
                window.hoculus.utils.getScriptAsync(hoculus.assets.js.gCalendar).then(() => {
                    window.calendar.schedulingButton.load({
                        url: this.dataset.calendarLink,
                        color: '#7432ff',
                        label: 'label',
                        target: btnTarget,
                    });
        
                    btnTarget.remove();
                });
            }
            catch (error) {
                console.error(error);
            }
        }

        clickHandler = () => {
            this.insertCss(this.dataset.stylesheet, "g-cal-stylesheet");
            this.gCalendarBtnWrapper?.querySelector("button")?.click();
        }

        insertCss (stylesheet, stylesheetId) {
            if (!document.getElementById(stylesheetId)) {
                const link = document.createElement('link');
                link.href = stylesheet;
                link.rel = 'stylesheet';
                link.id = stylesheetId;
                document.head.appendChild(link);
            }
        }
    }

    customElements.define("google-calendar-trigger", HoculusGoogleCalendarTrigger);
}
